import { Component, computed, inject } from '@angular/core';
import { OrbitFormClaimService } from '../services/orbit-form-claim.service';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'lib-orbit-questions.component',
  standalone: true,
  providers: [],
  imports: [CommonModule, FormsModule, ReactiveFormsModule],
  templateUrl: './orbit-questions.component.html',
  styleUrl: './orbit-questions.component.scss',
})
export class OrbitQuestionsComponent {
  formService = inject(OrbitFormClaimService);
  fb = inject(FormBuilder);
  mmrService;

  private viewModel = computed(() => {
    return {
      claimId: this.formService.state.claimId,
      currentQuestion: this.formService.state.currentQuestion,
      claimForm: this.fb.group({
        selectedAnswer: ['', Validators.required],
      }),
    };
  });

  get vm() {
    return this.viewModel();
  }

  get selectedAnswer() {
    return this.vm.claimForm.get('selectedAnswer') as FormControl;
  }

  get selectedQuestionType() {
    return this.vm.currentQuestion.answerType;
  }

  private markFormGroupTouched(): void {
    Object.keys(this.vm.claimForm.controls).forEach((key) => {
      const control = this.vm.claimForm.get(key);
      control?.markAsTouched();
    });
  }

  onSubmit(): void {
    if (this.vm.claimForm.valid) {
      this.submitForm();
    } else {
      console.log('Form is invalid');
      this.markFormGroupTouched();
    }
  }

  private submitForm(): void {
    const formData = {
      claimID: this.vm.claimId,
      QuestionID: this.vm.currentQuestion.questionID,
      AnswerID: this.getAnswerID(),
      AnswerValue: this.getAnswerValue(),
    };
    this.formService.putQuestion(formData);
  }

  private getAnswerValue() {
    if (this.vm.currentQuestion.answerType === 'RADIO_BUTTONS') {
      return this.vm.currentQuestion.answerData.find(
        (answer) =>
          answer.answerID === this.vm.claimForm.get('selectedAnswer')?.value
      ).answerLabel;
    } else if (this.vm.currentQuestion.answerType === 'RESPONSE_FIELD') {
      return this.vm.claimForm.get('selectedAnswer')?.value;
    }
  }

  private getAnswerID() {
    if (this.vm.currentQuestion.answerType === 'RADIO_BUTTONS') {
      return this.vm.currentQuestion.answerData.find(
        (answer) =>
          answer.answerID === this.vm.claimForm.get('selectedAnswer')?.value
      ).answerID;
    } else if (this.vm.currentQuestion.answerType === 'RESPONSE_FIELD') {
      return this.vm.currentQuestion.answerData[0].answerID;
    }
  }
}
